export default "__VITE_PUBLIC_ASSET__06599992__"